/* eslint-disable react-native/no-inline-styles */
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import i18next from 'i18next';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import LIBRE_SUPPORTED_LANGS from '../../../transcribing/libre-supported-langs.json';

interface ILanguageItem {
  id: string;
  lang: string;
  selected: boolean;
}

interface ILanguageListProps {
  items: Array<ILanguageItem>;
  onLanguageSelected: (lang: string) => void;
  selectedLanguage: string;
  t: (key: string) => string;
  switchEnabled: boolean;
  language: stringSimilarity;
}

const useStyles = makeStyles()(() => {
    return {
        itemsContainer: {
            display: 'flex',
            flexFlow: 'column'
        },
        dropdownContainer: {
            alignItems: 'anchor-center',
            display: 'flex',
            justifyContent: 'space-between'

            // width: '313px'
        },
        font16: {
            fontSize: '16px',
            fontWeight: '600'
        }
    };
});

/**
 * Component that renders the security options dialog.
 *
 * @returns {React$Element<any>}
 */
const LanguageList = ({
    onLanguageSelected,
    t,
    switchEnabled,
    language,
    translationEnabled
}: ILanguageListProps) => {
    const { classes: styles } = useStyles();

    const { language: currentLanguage } = i18next;


    const onLanguageSelectedWrapper = item => {
        onLanguageSelected(item);
    };

    const currentLangData = LIBRE_SUPPORTED_LANGS.find(lang => lang.code === currentLanguage);

    const targetLanguages = currentLangData ? currentLangData.targets : [];


    const translationListItems = targetLanguages.length > 0
        ? targetLanguages.map(item => (
            <DropdownItem
                key = { item }
                onClick = { () => onLanguageSelectedWrapper(item) }>
                { t(`languages:${item}`) }
            </DropdownItem>
        )) : (<DropdownItem disabled = { true }>
            { t('languages:not_available') }
        </DropdownItem>);

    return (
        <div className = { styles.itemsContainer }>
            <div
                className = 'dropdown-menu1'>
                {
                    switchEnabled && translationEnabled === true && (
                        <div
                            className = { styles.dropdownContainer }>
                            <span style = {{ fontSize: 16 }}>{ t('transcribing.TranslateTo') }</span>
                            { translationListItems.length > 0
                                ? <DropdownMenu
                                    className = 'dropdown-min-width'
                                    trigger = { t(`languages:${language.split('-')[0]}`) }
                                    triggerButtonProps = {{ shouldFitContainer: true }}
                                    triggerType = 'button'>
                                    <DropdownItemGroup>
                                        { translationListItems }
                                    </DropdownItemGroup>
                                </DropdownMenu> : <span className = { styles.font16 }>{ t('transcribing.TranslationNotAvailable') }</span> }
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default LanguageList;
